import { useTranslation } from 'react-i18next';
import { KoobPillGroup, KoobPill, KoobPillAdd, KoobBadge } from '@koob/ui';

const ItemPills = ({
  selectedIndex,
  onSelectIndex,
  items,
  isUnsaved,
  addDisabled = false,
  translation,
  disabled,
}) => {
  const { t } = useTranslation(translation);

  return (
    <div className="py-4">
      <KoobPillGroup>
        {(items || []).map((item, index) => {
          const node = item?.node ?? item;
          return (
            <KoobPill
              key={index}
              active={index === selectedIndex}
              onClick={() => !isUnsaved && onSelectIndex(index)}
            >
              {node?.displayName ||
                node?.enDisplayName ||
                node?.room?.displayName ||
                node?.room?.enDisplayName}

              {node?.isExternalSupplierOnly && (
                <KoobBadge color="purple">Ext-Only</KoobBadge>
              )}
            </KoobPill>
          );
        })}
        {!disabled && (
          <KoobPillAdd
            active={typeof selectedIndex !== 'number'}
            disabled={addDisabled}
            disabledTip={t('selectEnglish')}
            onClick={() => !isUnsaved && !addDisabled && onSelectIndex(null)}
          >
            {t('misc:add')}
          </KoobPillAdd>
        )}
      </KoobPillGroup>
    </div>
  );
};

export default ItemPills;
